'use client';

import { useEffect } from 'react';
import { getStore } from '~/mobx/AppStore';
import { UserSessionData } from '~/types/generalSession';

type Props = {
    user?: UserSessionData;
};

const Client = (props: Readonly<Props>) => {
    const { user } = props;
    useEffect(() => {
        const { userStore } = getStore();
        if (user) {
            userStore.setUser(user);
        }
        userStore.setIsInitialized(true);
    }, [user]);

    return null;
};

export default Client;
